module.exports = __webpack_public_path__ + "img/6.e06e5917.jpg";